module.exports = __webpack_public_path__ + "img/partner-new2.77877017.png";